export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./support.vue?vue&type=template&id=1b1bf4de"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/support.vue?vue&type=template&id=1b1bf4de
// module id = W6TN
// module chunks = 0